module.exports = __webpack_public_path__ + "static/grafika7-87b88d3af83bf1d8c92c4e112c5445b2.png";